import { MenuItem, Popover } from '@mui/material'
import useStyles from './styles'
import React, { useRef, useState } from 'react'
import { ExtraSmallButton } from '../../../custom'

export type FontSizeSelectorProps = {
    value: number,
    onChange: (value: number) => void
    compact?: boolean
}

const FontSizeSelector: React.FC<FontSizeSelectorProps> = ({ value, compact = false, onChange }) => {
    const { classes, cx } = useStyles()
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)

    const ref = useRef<HTMLDivElement>(null)

    return <div ref={ref}>
        <ExtraSmallButton style={{ padding: '8px' }} className={cx(classes.container, {
            [classes.compact]: compact
        })} onClick={() => setAnchorEl(ref.current)}>
            {value}
        </ExtraSmallButton>
        <Popover
            elevation={3}
            open={Boolean(anchorEl)}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
            }}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
        >
            {[10, 11, 12, 14, 16, 20, 24, 28, 32, 40].map((fontSize) => (
                <MenuItem selected={value === fontSize} key={fontSize} onClick={() => {
                    onChange(fontSize)
                    setAnchorEl(null)
                }}>
                    {fontSize}
                </MenuItem>
            ))}
        </Popover>
    </div>
}

export default FontSizeSelector

